<ul class="wf-file-list__list">
  @for (file of files(); track file.id) {
    <li
      class="wf-file-list__item"
      [class.wf-file-list__item--active]="file.id === activeFileId()"
      (click)="onView(file)"
    >
      @if (file.iconUrl) {
        <img
          class="wf-file-list__icon-image"
          width="24"
          height="32"
          [ngSrc]="file.iconUrl"
          [alt]="file.name"
        />
      } @else {
        <wf-icon
          class="wf-file-list__icon"
          iconClass="mini"
          [iconName]="file.iconName ?? 'file_06'"
        />
      }

      <span class="wf-file-list__name wf-text-sm-medium">{{ file.name }}</span>

      @if (file.downloadable !== false) {
        <button
          type="button"
          class="wf-file-list__action"
          (click)="onDownload(file, $event)"
        >
          <wf-icon iconName="download_03" iconClass="mini" />
        </button>
      }
    </li>
  }
</ul>
